module.exports = __webpack_public_path__ + "img/empty-search@2x.a54eba59.png";